import { Mobile, Pc } from '../../hooks/MediaQuery'
import Page7Pc from './Page7Pc'
import Page7Mobile from './Page7Mobile'
import { useEffect, useState } from 'react'
import { selectLocationBanner } from '../../api/x_banner'
import { selectSocialList } from '../../api/x_social'
function Page7() {
  const [bannerList, setBanner] = useState([])
  const [socialList, setSocialList] = useState([])

  useEffect(() => {
    async function fetchBanner() {
      const response = await selectLocationBanner({ code: 'BANNER_04' })
      const data = response.data.data
      setBanner(data)
    }

    async function fetchSocial() {
      const response = await selectSocialList({ useYn: 'Y' })
      const data = response.data.data
      setSocialList(data)
    }

    fetchBanner()
    fetchSocial()
  }, [])

  return (
    <>
      <Pc>
        <Page7Pc bannerList={bannerList} socialList={socialList} />
      </Pc>
      <Mobile>
        <Page7Mobile bannerList={bannerList} socialList={socialList} />
      </Mobile>
    </>
  )
}

export default Page7
